import { audioService } from "../services/audioService";

export const analyzeResponse = (userResponse, correctAnswer) => {
  if (!userResponse.trim()) {
    audioService.playLocalAudio("no_answer.mp3");
    return {
      message: "আপনার উত্তর দিন",
      type: "warning",
    };
  }

  if (userResponse.trim().toLowerCase() === correctAnswer.toLowerCase()) {
    audioService.playLocalAudio("correct_answer.mp3");
    return {
      message: "উত্তর সঠিক হয়েছে",
      type: "success",
    };
  }

  audioService.playLocalAudio("wrong_answer.mp3");
  return {
    message: "উত্তর ভুল হয়েছে",
    type: "error",
  };
};

export const getAnalysisColorClasses = (analysisType) => {
  switch (analysisType) {
    case "success":
      return "text-green-600 bg-green-50 border-green-200";
    case "error":
      return "text-red-600 bg-red-50 border-red-200";
    default:
      return "text-blue-600 bg-blue-50 border-blue-200";
  }
};
